import './index.scss'
import {useRef, useState} from 'react'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import {Calendar} from 'react-date-range'
import {DateIcon, HelpIcon} from '../../../icons'
import useOutsideClick from '../../../utils/hooks/useOutsideClick'
import DateHelper from '../../../utils/date'
import Tooltip from '../tooltip'
import {colors} from '../../../utils/colors'
import Error from '../error'
import classNames from 'classnames'
import {useSelector} from 'react-redux'
import TimePicker from 'rc-time-picker'

const CustomCalendar = ({
    placeholder,
    isInfoDisabled,
    isDisabled,
    onChange,
    value,
    error,
    name,
    currentDate,
    infoText,
    infoIconSize,
    hasTimePicker,
    startTime,
    onChangeStartTime
}) => {
    const [isActive, setIsActive] = useState(false)
    const calendarRef = useRef()
    useOutsideClick(calendarRef, () => setIsActive(false))
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const handleChange = (item) => {
        onChange(DateHelper.convertToStandartDate(item))
    }

    return (
        <div className={classNames('calendar-container', {
            dark: isDarkMode
        })}>
            <div className='calendar-field'>
                <div
                    ref={calendarRef}
                    className={classNames('date-picker', {
                        active: isActive,
                        disabled: isDisabled
                    })}
                    onClick={() => setIsActive(!isActive)}
                >
                    <p className={`${(!value || isDisabled) ? 'placeholder-text' : ''}`}>{!isDisabled && value ? value : placeholder}</p>
                    <span className="icon">
                        {!isDisabled && <DateIcon/>}
                    </span>
                    {isActive && (
                        <div className={classNames('date-picker-box', {
                            'calendar-with-time': hasTimePicker
                        })} onClick={(e) => e.stopPropagation()}>
                            <Calendar
                                editableDateInputs={true}
                                onChange={(item) => handleChange(item)}
                                scroll={{enabled: true}}
                                value={value}
                                name={name}
                                date={currentDate}
                            />

                            {hasTimePicker && <span className={classNames('time-picker-box', {
                                'dark': isDarkMode
                            })}>
                                <TimePicker
                                    showSecond={false}
                                    onChange={(value) => onChangeStartTime(value)}
                                    clearIcon={<></>}
                                    inputReadOnly
                                    value={startTime}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                />
                            </span>}
                        </div>
                    )}
                </div>
                {!isInfoDisabled && <div className="tooltip-container">
                    <Tooltip placement="left" trigger="click" content={infoText} appendTo={calendarRef?.current}>
                        <HelpIcon stroke={colors.colorBgFilter} width={infoIconSize || '24'} height={infoIconSize || '24'} />
                    </Tooltip>
                </div>}
            </div>
            {error && <Error error={error} hasIcon/>}
        </div>
    )
}

export default CustomCalendar
